
import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectForm from '@/components/projects/ProjectForm';

const EditProjectPage = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) return null;

  return <ProjectForm projectId={id} />;
};

export default EditProjectPage;
